import React from 'react';

type Item = { label: string; score: number };

type Props = {
  title: string;
  items: Item[];
  hint?: string;
};

export function MiniBarChart({ title, items, hint }: Props) {
  const max = Math.max(1, ...items.map((i) => i.score));

  return (
    <div className="lbf-card p-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-sm font-extrabold text-white">{title}</div>
          {hint ? <div className="mt-1 text-xs text-zinc-300/80">{hint}</div> : null}
        </div>
        <div className="lbf-badge">Score /100</div>
      </div>

      <div className="mt-4 grid gap-3">
        {items.map((i) => {
          const w = Math.round((i.score / max) * 100);
          return (
            <div key={i.label} className="grid gap-2">
              <div className="flex items-center justify-between text-xs">
                <div className="font-semibold text-white/85">{i.label}</div>
                <div className="tabular-nums text-zinc-200/85">{i.score}</div>
              </div>
              <div className="h-2 overflow-hidden rounded-full bg-white/10">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-fuchsia-500 to-indigo-500"
                  style={{ width: `${w}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}


